import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const QuickActionCard = ({ title, description, icon, actionLabel, onAction, variant = 'default' }) => {
  const variantStyles = {
    default: 'border-border bg-card',
    primary: 'border-primary/20 bg-primary/5',
    warning: 'border-warning/20 bg-warning/5',
    success: 'border-success/20 bg-success/5'
  };

  const iconColors = {
    default: 'text-text-secondary',
    primary: 'text-primary',
    warning: 'text-warning',
    success: 'text-success'
  };

  return (
    <div className={`border rounded-lg p-6 transition-all duration-150 hover:shadow-md ${variantStyles?.[variant]}`}>
      <div className="flex items-start gap-4">
        <div className={`p-3 rounded-lg bg-background ${iconColors?.[variant]}`}>
          <Icon name={icon} size={24} />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-lg font-semibold text-text-primary mb-1">{title}</h3>
          <p className="text-sm text-text-secondary mb-4">{description}</p>
          <Button
            variant={variant === 'default' ? 'outline' : variant}
            size="sm"
            onClick={onAction}
            iconName="ArrowRight"
            iconPosition="right"
            iconSize={14}
          >
            {actionLabel}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default QuickActionCard;